import { FC } from "react";
import ConfigureGptView from "./ConfigureGptView";

const ConfigureGptHandler: FC = () => {
    return <ConfigureGptView />
}

export default ConfigureGptHandler;
